import { render } from "./serviceList.vue?vue&type=template&id=31c6cf47&scoped=true"
import script from "./serviceList.vue?vue&type=script&lang=js"
export * from "./serviceList.vue?vue&type=script&lang=js"

import "./serviceList.vue?vue&type=style&index=0&id=31c6cf47&scoped=true&lang=css"
import "./serviceList.vue?vue&type=style&index=1&id=31c6cf47&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c6cf47"]])

export default __exports__